/* Model */
class SecurityPolicyModel extends App.Models.BaseModel {
  modelUrl = 'SecurityPolicy';
}

App.Models.SecurityPolicy = SecurityPolicyModel;

/* Collection */
class SecurityPolicyCollection extends App.Collections.BaseCollection {
  url = 'SecurityPolicy';
  model = App.Models.SecurityPolicy;
}

App.Collections.SecurityPolicys = SecurityPolicyCollection;

/* Router */
class SecurityPolicyRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'SecurityPolicy';
      const model = App.Models.SecurityPolicy;
      const collectionClass = App.Collections.SecurityPolicys;

      super(entityName, model, collectionClass);
  }
}

App.Routers.SecurityPolicy = SecurityPolicyRouter;